import React, { forwardRef } from "react";
import Select from "react-select";

const CommonDropdown = forwardRef(
  (
    {
      value,
      name,
      isMulti,
      isSearchable,
      label,
      readOnly,
      isClearable = true,
      styles,
      components,
      ...props
    },
    ref
  ) => {
    const isDisabled = readOnly;
    return (
      <div>
        {label && (
          <label>
            <span dangerouslySetInnerHTML={{ __html: label }}></span>
          </label>
        )}
        <Select
          name={name}
          value={value ?? ""}
          closeMenuOnSelect={true}
          isMulti={isMulti}
          isSearchable={isSearchable}
          isDisabled={isDisabled}
          {...props}
          isClearable={isClearable}
          styles={styles}
          // closeMenuOnSelect={false}
          className="react-select-container"
          classNamePrefix="react-select"
          components={components}
        />
      </div>
    );
  }
);

export default CommonDropdown;
